"use strict";
exports.__esModule = true;
exports.shouldRunAutoUpdate = exports.TIME_INTERVAL_BOUNDARY = exports.getLastUpdate = exports.fetchOnlajnyEuData = exports.transformData = exports.isGfyMultimediaContent = exports.REFRESH_INTERVAL = void 0;
var tslib_1 = require("tslib");
var date_fns_1 = require("date-fns");
var subMinutes_1 = tslib_1.__importDefault(require("date-fns/subMinutes"));
var setHours_1 = tslib_1.__importDefault(require("date-fns/setHours"));
var setMinutes_1 = tslib_1.__importDefault(require("date-fns/setMinutes"));
var CmsApi_1 = tslib_1.__importDefault(require("../../../api/CmsApi"));
var max_1 = tslib_1.__importDefault(require("date-fns/max"));
var addMinutes_1 = tslib_1.__importDefault(require("date-fns/addMinutes"));
exports.REFRESH_INTERVAL = 60; // [sekund]
// stavy zatial nezacateho zapasu
//
// possible - conditioned match, usually in a hockey play-offs series
// scheduled - not started yet
// postponed - will start later
var SHEDULED_MATCH_STATUSES = ['possible', 'scheduled', 'postponed'];
// stavy prebiehajuceho zapasu
//
// intermission - between periods
// live         - is being played at this moment
// interrupted  - started and will continue later, mainly in tennis
var ONGOING_MATCH_STATUSES = ['live', 'intermission', 'interrupted'];
exports.isGfyMultimediaContent = function (comment) {
    return (comment.label === 'multimedia' &&
        (comment.message || '').includes('gfyitem'));
};
exports.transformData = function (data) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32;
    var eventDate;
    if ((_b = (_a = data.data) === null || _a === void 0 ? void 0 : _a.event) === null || _b === void 0 ? void 0 : _b.start_date) {
        eventDate = new Date((_d = (_c = data.data) === null || _c === void 0 ? void 0 : _c.event) === null || _d === void 0 ? void 0 : _d.start_date);
        if ((_f = (_e = data.data) === null || _e === void 0 ? void 0 : _e.event) === null || _f === void 0 ? void 0 : _f.start_time) {
            var _33 = (_h = (_g = data.data) === null || _g === void 0 ? void 0 : _g.event) === null || _h === void 0 ? void 0 : _h.start_time.split(':'), hours = _33[0], minutes = _33[1];
            eventDate = setHours_1["default"](eventDate, Number(hours));
            eventDate = setMinutes_1["default"](eventDate, Number(minutes));
        }
    }
    return {
        sport: (_j = data.data) === null || _j === void 0 ? void 0 : _j.sport,
        competitionName: ((_l = (_k = data.data) === null || _k === void 0 ? void 0 : _k.competition) === null || _l === void 0 ? void 0 : _l.long_name) || ((_o = (_m = data.data) === null || _m === void 0 ? void 0 : _m.competition) === null || _o === void 0 ? void 0 : _o.short_name),
        eventName: (_q = (_p = data.data) === null || _p === void 0 ? void 0 : _p.event) === null || _q === void 0 ? void 0 : _q.long_name,
        eventDateTime: eventDate,
        eventSpecification: (_s = (_r = data.data) === null || _r === void 0 ? void 0 : _r.event) === null || _s === void 0 ? void 0 : _s.specification,
        season: (_u = (_t = data.data) === null || _t === void 0 ? void 0 : _t.event) === null || _u === void 0 ? void 0 : _u.season,
        score: ((_x = (_w = (_v = data.data) === null || _v === void 0 ? void 0 : _v.scoreboard) === null || _w === void 0 ? void 0 : _w.results) === null || _x === void 0 ? void 0 : _x.score1) + ":" + ((_0 = (_z = (_y = data.data) === null || _y === void 0 ? void 0 : _y.scoreboard) === null || _z === void 0 ? void 0 : _z.results) === null || _0 === void 0 ? void 0 : _0.score2),
        periodsScores: (((_3 = (_2 = (_1 = data.data) === null || _1 === void 0 ? void 0 : _1.scoreboard) === null || _2 === void 0 ? void 0 : _2.results) === null || _3 === void 0 ? void 0 : _3.period) || []).map(function (i) { return i.score1 + ":" + i.score2; }),
        setScores: (((_6 = (_5 = (_4 = data.data) === null || _4 === void 0 ? void 0 : _4.scoreboard) === null || _5 === void 0 ? void 0 : _5.results) === null || _6 === void 0 ? void 0 : _6.period) || []).map(function (i) { return i.total_score1 + ":" + i.total_score2; }),
        time: ((_8 = (_7 = data.data) === null || _7 === void 0 ? void 0 : _7.scoreboard) === null || _8 === void 0 ? void 0 : _8.last_time) || ((_10 = (_9 = data.data) === null || _9 === void 0 ? void 0 : _9.scoreboard) === null || _10 === void 0 ? void 0 : _10.actual_time),
        stats: (_11 = data.data) === null || _11 === void 0 ? void 0 : _11.stats,
        opponent1Name: ((_13 = (_12 = data.data) === null || _12 === void 0 ? void 0 : _12.opponent1) === null || _13 === void 0 ? void 0 : _13.short_name) || ((_15 = (_14 = data.data) === null || _14 === void 0 ? void 0 : _14.opponent1) === null || _15 === void 0 ? void 0 : _15.long_name),
        opponent1Id: (_17 = (_16 = data.data) === null || _16 === void 0 ? void 0 : _16.opponent1) === null || _17 === void 0 ? void 0 : _17.logo_id,
        opponent2Name: ((_19 = (_18 = data.data) === null || _18 === void 0 ? void 0 : _18.opponent2) === null || _19 === void 0 ? void 0 : _19.short_name) || ((_21 = (_20 = data.data) === null || _20 === void 0 ? void 0 : _20.opponent2) === null || _21 === void 0 ? void 0 : _21.long_name),
        opponent2Id: (_23 = (_22 = data.data) === null || _22 === void 0 ? void 0 : _22.opponent2) === null || _23 === void 0 ? void 0 : _23.logo_id,
        matchStatus: (_26 = (_25 = (_24 = data.data) === null || _24 === void 0 ? void 0 : _24.scoreboard) === null || _25 === void 0 ? void 0 : _25.status) === null || _26 === void 0 ? void 0 : _26.type,
        comments: (((_28 = (_27 = data.data) === null || _27 === void 0 ? void 0 : _27.comments) === null || _28 === void 0 ? void 0 : _28.comment) || []).map(function (i) {
            var _a;
            return ({
                id: i.id,
                order: i.order,
                time: (_a = i.time) === null || _a === void 0 ? void 0 : _a._,
                label: i.label,
                message: i.message
            });
        }),
        lastChange: ((_29 = data.data) === null || _29 === void 0 ? void 0 : _29.last_change) ? new Date((_30 = data.data) === null || _30 === void 0 ? void 0 : _30.last_change)
            : null,
        lastChangeScoreboard: ((_31 = data.data) === null || _31 === void 0 ? void 0 : _31.last_change_scoreboard) ? new Date((_32 = data.data) === null || _32 === void 0 ? void 0 : _32.last_change_scoreboard)
            : null
    };
};
exports.fetchOnlajnyEuData = function (appId, appSpace, contentDivider, url) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var result;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, CmsApi_1["default"].expandWidgets(appId, appSpace, contentDivider, {}, {
                    content: [{ type: 'onlajny.eu', url: url }]
                })];
            case 1:
                result = _a.sent();
                return [2 /*return*/, result];
        }
    });
}); };
exports.getLastUpdate = function (lastUpdate, lastUpdateScoreboard) {
    if (!lastUpdateScoreboard) {
        return lastUpdate;
    }
    var r = max_1["default"]([new Date(lastUpdate), new Date(lastUpdateScoreboard)]);
    return r;
};
exports.TIME_INTERVAL_BOUNDARY = 15;
exports.shouldRunAutoUpdate = function (transformedData) {
    var now = new Date();
    if (!transformedData) {
        return false;
    }
    if (transformedData.eventDateTime &&
        transformedData.lastChange &&
        transformedData.matchStatus) {
        // ak som v intervale 15 minut pred zaciatkom a sucasne 15 minut po poslednom update
        var lastUpdate = exports.getLastUpdate(transformedData.lastChange, transformedData.lastChangeScoreboard);
        var intervalStart = subMinutes_1["default"](transformedData.eventDateTime, exports.TIME_INTERVAL_BOUNDARY);
        var intervalEnd = addMinutes_1["default"](lastUpdate, exports.TIME_INTERVAL_BOUNDARY);
        var beforeMatch = SHEDULED_MATCH_STATUSES.includes(transformedData.matchStatus) &&
            date_fns_1.isAfter(now, intervalStart);
        var isLive = ONGOING_MATCH_STATUSES.includes(transformedData.matchStatus);
        var afterMatch = date_fns_1.isAfter(now, intervalStart) && date_fns_1.isBefore(now, intervalEnd);
        if (beforeMatch || isLive || afterMatch) {
            return true;
        }
    }
    return false;
};
